// extracted by mini-css-extract-plugin
module.exports = {"EditorWrapper":"Editor_EditorWrapper__wSYe2","ReadOnly":"Editor_ReadOnly__I9QhK"};